/**
 * Created by om on 05/01/17.
 */
export default class Iterator {

  constructor() {
  }

  /**
   * @return {boolean}
   */
  hasNext() {
    throw new Error('Not implemented');
  }

  /**
   * @return {*}
   */
  next() {
    throw new Error('Not implemented');
  }

  remove() {
    throw new Error('Not implemented');
  }
}